"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.assist.attachKnowledge': 'Attach Knowledge:',
    'ai.assist.knowledgeFound': 'Relevant knowledge found',
    'ai.assist.relevantKnowledgeFound': 'Relevant knowledge found after conversation',
    'ai.assist.attachmentIds': 'Attachment IDs',
    'ai.assist.clickForSuggestions': 'Click to view AI suggestions',
};
